// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__3RrHc","list":"PatternAutocomplete_list__28pw_"};